import {connect} from '@store/@common';
import {KpiTargetId} from '@store/@types/kpi';
import KpiGoalActions from '@store/kpi/KpiTargetActions';

import {GoalKpiRow} from './GoalKpiRow';

const mapStateToProps = {};

const mapActionsToProps = {
  deleteKpi: async (id: KpiTargetId) => {
    await KpiGoalActions.delete(id);
    await KpiGoalActions.fetchGoalKpiTree();
  },
  toggleKpi: KpiGoalActions.toggleKpi,
};

export default connect(GoalKpiRow, mapStateToProps, mapActionsToProps);
